module.exports = "img/upload.6ac72f0.png";